export default __webpack_public_path__ + "static/media/ParallelRobotArmImg.7747b0bb.png";